import { h, Component, Prop } from '@stencil/core';
import { Root } from '../../types/entities';
import { parseRootProps } from '../../utils/parse-helper';

@Component({
  tag: 'ps-link',
  styleUrl: 'link.styles.scss',
})
export class Link {
  @Prop() color: 'primary' | 'secondary' = 'primary';
  @Prop() target: '_self' | '_blank' = '_self';
  @Prop() href?: string;
  @Prop() root?: Root;

  // click is a standard DOM event
  // event-definintion is only needed for custom events
  // @Event() click: EventEmitter;

  getClassNames = (rootClass: string) => {
    const classes = ['ds-link', `ds-link__${this.color}`];
    if (rootClass) {
      classes.push(rootClass);
    }
    return classes.join(' ');
  };

  getTargetIcon = () => {
    const arrow = this.target === '_blank' ? 'open_in_new' : 'east';
    return (
      <ps-box ml={1} inline>
        <ps-material-icon symbol={arrow} size="standard"></ps-material-icon>
      </ps-box>
    );
  };

  render() {
    const { rootClass, attr } = parseRootProps(this.root);
    const classNames = this.getClassNames(rootClass);

    return (
      <ps-box px={0.25} class={classNames} inline>
        <a {...attr} href={this.href} target={this.target}>
          <slot></slot>
          {this.getTargetIcon()}
        </a>
      </ps-box>
    );
  }
}
